import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const KcalIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 13 18" {...props}>
      <path
        d="M6.24947 17.9167C4.99709 17.9166 3.77364 17.5402 2.73772 16.8364C1.70181 16.1326 0.901219 15.1339 0.439756 13.9696C-0.0217064 12.8054 -0.122758 11.5293 0.149704 10.3069C0.422165 9.08456 1.05557 7.97223 1.9678 7.11417C3.08613 6.06167 5.8328 4.16667 5.41613 0C10.4161 3.33333 12.9161 6.66667 7.91613 11.6667C8.74947 11.6667 9.99947 11.6667 12.0828 9.60833C12.3078 10.2525 12.4995 10.945 12.4995 11.6667C12.4995 13.3243 11.841 14.914 10.6689 16.0861C9.49678 17.2582 7.90707 17.9167 6.24947 17.9167Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="12.4995"
          y1="8.95871"
          x2="-4.48557e-08"
          y2="8.95871"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF972C" />
          <stop offset="1" stopColor="#FFBA1B" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export default KcalIcon;
